/* ----------------------------- Main description collapsible on mobile ----------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  const description = document.getElementById("collection-description");
  const toggleButton = document.getElementById("toggle-collection-description");

  if (!description || !toggleButton) return;

  const labelShowMore = toggleButton.getAttribute("label-show-more");
  const labelShowLess = toggleButton.getAttribute("label-show-less");

  toggleButton.addEventListener("click", function () {
    const isCollapsed = description.classList.toggle("collapsed");
    toggleButton.textContent = isCollapsed ? labelShowMore : labelShowLess;
    toggleButton.setAttribute("aria-expanded", String(!isCollapsed));
  });
});

/* ----------------------------- Large bottom description collapsible-content ----------------------------- */
document.querySelectorAll('.collapsible-content').forEach((contentEl) => {
  const btn = contentEl.parentElement.querySelector('.toggle-content-btn');
  if (!btn) return;

  const needsCollapse =
    contentEl.scrollHeight > 320;
  if (!needsCollapse) {
    btn.remove();
    contentEl.classList.remove('collapsed');
    return;
  }

  btn.addEventListener('click', () => {
    if (contentEl.classList.contains('collapsed')) {
      contentEl.classList.remove('collapsed');
      btn.setAttribute('aria-expanded', 'true');
      btn.remove();
    }
  }, { once: true });
});